/**
 * @file Frontend API client — submissionService.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

// ------------------------------------
// CREATE SUBMISSION
// ------------------------------------
export const createSubmission = async (payload: any = {}) => {
  return axiosClient.post(API_URLS.SUBMISSIONS.CREATE, payload);
};

// ------------------------------------
// GET ALL MY SUBMISSIONS
// ------------------------------------
export const getMySubmissions = async () => {
  return axiosClient.get(API_URLS.SUBMISSIONS.MINE);
};

// ------------------------------------
// FLAGGED — needs contributor action (admin return or expert flag)
// ------------------------------------
export const getFlaggedSubmissions = async () => {
  return axiosClient.get(API_URLS.SUBMISSIONS.FLAGGED);
};

// ------------------------------------
// GET A SUBMISSION BY ID (FULL DATA)
// ------------------------------------
export const getSubmissionById = async (
  id: string,
  options?: { includeFormFields?: boolean }
) => {
  const params: Record<string, string> = {};
  if (options?.includeFormFields) params.includeFormFields = "true";
  return axiosClient.get(API_URLS.SUBMISSIONS.BY_ID(id), {
    params: Object.keys(params).length ? params : undefined,
  });
};

// ------------------------------------
// GET A SUBMISSION BY ID (FULL DATA)
// ------------------------------------
export const deleteSubmissionById = async (id: string) => {
  return axiosClient.delete(API_URLS.SUBMISSIONS.DELETE(id));
};

// ------------------------------------
// SAVE CONTRIBUTOR DETAILS (Stage 1)
// ------------------------------------
export const saveContributorDetails = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/contributor`, payload);
};

// ------------------------------------
// SAVE PUBLICATION DETAILS (Stage 2)
// ------------------------------------
export const savePublicationDetails = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/publication`, payload);
};

// ------------------------------------
// SAVE BACKGROUND DATA (Stage 3)
// ------------------------------------
export const saveBackgroundData = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/background`, payload);
};

// ------------------------------------
// UPLOAD BACKGROUND FILES (material image + publication) — multipart
// ------------------------------------
export const uploadBackgroundFiles = async (
  id: string,
  formData: FormData
) => {
  return axiosClient.post(`/submissions/${id}/background/files`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// ------------------------------------
// SAVE A1 Stage
// ------------------------------------
export const saveA1Stage = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/a1`, payload);
};

// ------------------------------------
// SAVE A2 Stage
// ------------------------------------
export const saveA2Stage = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/a2`, payload);
};

// ------------------------------------
// SAVE A3 Stage
// ------------------------------------
export const saveA3Stage = async (id: string, payload: any) => {
  return axiosClient.put(`/submissions/${id}/a3`, payload);
};


/* ===============================
   UPDATE SUBMISSION STAGE
================================ */


export const updateSubmissionStage = (
  submissionId: string,
  stage: string
) => {
  return axiosClient.put(API_URLS.SUBMISSIONS.STAGE(submissionId), {
    stage,
  });
};

/** Exported const — save A1A3Summary. */
export const saveA1A3Summary = (
  submissionId: string,
  payload: {
    embodiedEnergyValue: number;
    embodiedEnergyUnit: string;
    embodiedCarbonValue: number;
    embodiedCarbonUnit: string;
  }
) => {
  return axiosClient.post(API_URLS.SUBMISSIONS.A1_A3(submissionId), payload);
};

// ------------------------------------
// ADMIN: APPROVE SUBMISSION / DATASET
// ------------------------------------
export const adminApproveSubmission = async (submissionId: string) => {
  return axiosClient.post(API_URLS.ADMIN.SUBMISSIONS.APPROVE(submissionId));
};